import styled from 'styled-components'
export const Text = styled("div")<{textAlign?: string, colorStrengh?: boolean}>`
color:${(props) => props.colorStrengh ? "#fff" : "#dcddde"};
text-align: ${(props) => props.textAlign || "center"}
`